import { RequestParamsType, RequestResponse } from 'hooks/types/client';
import useRequest from '../client/useRequest';

type Options = { refetch: string };

type UseRecentTags = (options?: Options) => RequestResponse<'tags.extras.recent'>;

const useRecentTags: UseRecentTags = (options) => {
  const params: RequestParamsType = {
    queryParams: {
      ...options,
    },
  };

  const result = useRequest('tags.extras.recent', params);

  return result;
};

export default useRecentTags;
